import React, { useMemo, useState } from 'react';
import AppIcon from '@atlaskit/icon/core/app';
import { CommandActionType } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { AsyncCommandPalette } from '@atlassian/jira-forge-ui-async/src/ui/command-palette/async.tsx';
import type { Command as CommandExtension } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { COMMAND_PALETTE_SECTIONS } from '@atlassian/jira-command-palette-common/src/common/constants.tsx';
import { RegisterForgeCommands } from '../../controller/RegisterForgeCommands.tsx';
import type { CommandsWithAction } from '../../types.tsx';
import { FORGE_COMMAND_PALETTE_ICON_MAP } from '../../constants.tsx';

export const ForgeModalCommands = ({ commands }: { commands: CommandExtension[] }) => {
	const [modalExtension, setModalExtension] = useState<CommandExtension | null>(null);

	const commandsWithActions = useMemo(
		() => generateCommandActions(commands, setModalExtension),
		[commands],
	);
	return (
		<>
			<RegisterForgeCommands commands={commandsWithActions} />
			{modalExtension && (
				<AsyncCommandPalette
					onClose={() => {
						setModalExtension(null);
					}}
					extension={modalExtension}
				/>
			)}
		</>
	);
};

export const generateCommandActions = (
	commands: Array<CommandExtension>,
	setModalExtension: React.Dispatch<React.SetStateAction<CommandExtension | null>>,
): Array<CommandsWithAction> =>
	commands.map((extension) => {
		const { id, properties } = extension;
		const { title, keywords, shortcut, icon } = properties;

		const LeftIcon = FORGE_COMMAND_PALETTE_ICON_MAP[icon];
		const components = LeftIcon ? { LeftIcon } : { LeftIcon: () => <AppIcon label="" /> };

		return {
			id,
			title,
			icon,
			keywords: keywords?.join(' '),
			section: COMMAND_PALETTE_SECTIONS.forge,
			components,
			shortcut,
			name: title,
			primaryAction: {
				type: CommandActionType.PERFORM,
				perform: () => {
					setModalExtension(extension);
				},
			},
		};
	});
